// src/auth/FetchInterceptor.js
import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';

const service = axios.create({
	baseURL: API_BASE_URL,
	timeout: 60000,
});

// ── Request interceptor ──────────────────────────────────────────
service.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem(AUTH_TOKEN);
		if (token) {
			config.headers['Authorization'] = token; // "Bearer xxxx"
		}
		return config;
	},
	(error) => {
		notification.error({ message: 'Error de configuración' });
		return Promise.reject(error);
	}
);

// ── Response interceptor ─────────────────────────────────────────
service.interceptors.response.use(
	(response) => response.data,
	(error) => {
		const status = error.response?.status;

		const notifParam = { message: '' };

		if (status === 401) {
			notifParam.message = 'Sesión expirada';
			notifParam.description = 'Por favor, inicia sesión nuevamente.';

			localStorage.removeItem(AUTH_TOKEN);
			localStorage.removeItem('user');
			store.dispatch(signOutSuccess());

		} else if (status === 403) {
			notifParam.message = 'Sin permiso';
			notifParam.description = 'No tienes autorización para realizar esta acción.';

		} else if (status === 404) {
			notifParam.message = 'Recurso no encontrado';

		} else if (status === 422) {
			// El componente maneja los errores de validación
			return Promise.reject(error);

		} else if (status === 500) {
			notifParam.message = 'Error interno del servidor';

		} else if (status === 503) {
			notifParam.message = 'Servicio no disponible';
		}

		if (notifParam.message) {
			notification.error(notifParam);
		}

		return Promise.reject(error);
	}
);

export default service;